// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3a_a0","rootMobile":"styles_rootMobile__3zuGo"};